import { Field, getIn } from 'formik'
import React from 'react'
import { useParams } from 'react-router-dom'

import { useDashboardFeatureFlags } from '@components/utils/DashboardFeatureFlags'
import { FeatureFlagDecorator } from '@components/utils/FeatureFlagDecorator'
import { Fieldset, Subsection } from '@fourthwall/components'
import { useFormikContext } from '@fourthwall/utils/dist/formik'

import { getFulfillmentType } from '../../../../Product.utils'
import { useOfferQuery } from '../../../../hooks'
import type { ProductFormState } from '../../../SingleProduct.types'
import { PackageSizeInputFormik } from '../shared/PackageSizeSelect/PackageSizeInput'
import { ShippingStartDate } from '../shared/ShippingStartDate/ShippingStartDate'
import { ShipmentWeightField } from '../shared/ShippingWeight/ShipmentWeightField'
import { TaxFields } from '../shared/TaxFields'

export const ProductShippingBespoke = () => {
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()
  const { values, errors } = useFormikContext<ProductFormState>()
  const fulfillmentType = getFulfillmentType(values.fulfillmentService)
  const { productId = '' } = useParams<'productId'>()
  const { offerQuery } = useOfferQuery([productId])
  const { shippingConfig } = offerQuery?.data?.config || {}

  return (
    <>
      <Subsection title="Shipping">
        <p>
          All the orders are produced and shipped at once. During checkout, supporters pay the cost
          of shipping, based on the weight of their order.
        </p>

        <ShipmentWeightField />

        <ShippingStartDate />
      </Subsection>

      <FeatureFlagDecorator {...dashboardFeatureFlags.hsCodes} wrapper={Subsection}>
        <TaxFields showLearnMoreLinks />

        {fulfillmentType === 'SHIP_MONK' ||
          (fulfillmentType === 'CART_JAZZ' && (
            <Fieldset.Row>
              <Fieldset.Item>
                <Field
                  component={PackageSizeInputFormik}
                  shippingConfig={shippingConfig}
                  name="shippingPackageSize"
                  label="Product size"
                  error={getIn(errors, 'shippingPackageSize')}
                />
              </Fieldset.Item>
            </Fieldset.Row>
          ))}
      </FeatureFlagDecorator>
    </>
  )
}
